export const chatNodeSystemPromptTip =
  '模型固定的引导词，通过调整该内容，可以引导模型聊天方向。该内容会被固定在上下文的开头。可使用变量，例如 {language}';
export const userGuideTip = '可以在对话前设置引导语，设置全局变量，设置下一步指引';
export const welcomeTextTip = 'core.app.tip.welcomeTextTip';
export const variableTip = 'core.app.tip.variableTip';
